import React from 'react';
import './PrivacyPolicyPage.css';

const PrivacyPolicyPage: React.FC = () => {
  return (
    <div className="privacy-page">
      <header className="privacy-header">
        <div className="privacy-header-inner">
          <span className="privacy-logo">시큐센터 (Security Center)</span>
        </div>
      </header>

      <main className="privacy-main">
        <div className="privacy-container">
          <div className="privacy-title-block">
            <h1>개인정보 처리방침</h1>
            <p className="privacy-intro">
              브이엔티지 정보보호 포탈(이하 &quot;정보보호 포탈&quot;)을 관리하고 있는 주식회사 브이엔티지(이하 &quot;회사&quot;)는
              고객님의 개인정보보호를 매우 중요시하며 「개인정보 보호법」, 「정보통신망 이용 촉진 및 정보보호 등에 관한 법률」 등
              개인정보보호 관련 법률 및 하위 법령들을 준수하고 있습니다. 회사는 고객의 개인정보 보호 및 권익을 보호하고
              개인정보와 관련한 고객의 고충을 원활하게 처리할 수 있도록 다음과 같은 처리 방침을 두고 있습니다.
            </p>
            <p className="privacy-intro">
              회사의 개인정보 처리 방침은 회사의 필요 또는 관련 법률 및 하위 법령의 개정에 따라 변경될 수 있습니다.
              개인정보 처리 방침을 개정하는 경우 사전에 정보보호 포탈 공지사항(또는 개별공지)을 통하여 공지할 것입니다.
            </p>
          </div>

          <nav className="privacy-toc">
            <h2>목차</h2>
            <ol>
              <li><a href="#article1">1. 개인정보 수집목적 및 이용목적</a></li>
              <li><a href="#article2">2. 개인정보의 보유 및 이용기간</a></li>
              <li><a href="#article3">3. 제3자에 대한 제공</a></li>
              <li><a href="#article4">4. 정보주체의 권리 및 행사방법</a></li>
            </ol>
          </nav>

          <section id="article1" className="privacy-section">
            <h2><span className="article-num">1.</span> 개인정보 수집목적 및 이용목적</h2>
            <p>
              정보보호 포탈은 다음의 목적을 위하여 개인정보를 처리합니다.
              처리하고 있는 개인정보는 다음의 목적 이외의 용도로는 이용되지 않으며, 이용 목적이 변경되는 경우에는
              「개인정보 보호법」 제18조에 따라 별도의 동의를 받는 등 필요한 조치를 이행할 예정입니다.
            </p>
            <p>⦁ 정보주체의 동의를 받지 않고 처리하는 개인정보 항목</p>
            <div className="privacy-table-wrap">
              <table className="privacy-table">
                <thead>
                  <tr>
                    <th>법적 근거</th>
                    <th>구분</th>
                    <th>수집 목적</th>
                    <th>수집 항목</th>
                    <th>보유 및 이용기간</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>개인정보 보호법 제15조 제1항 제4호 (계약의 이행)</td>
                    <td>정보보호 포탈 서비스 운영</td>
                    <td>서비스 이용에 따른 본인 식별/인증 절차, 서비스 권한 처리</td>
                    <td>성명, 이메일 주소, 부서</td>
                    <td>사별 퇴사프로세스에 따름</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </section>

          <section id="article2" className="privacy-section">
            <h2><span className="article-num">2.</span> 개인정보의 보유 및 이용기간</h2>
            <ol>
              <li>
                회사는 법령에 따른 개인정보 보유·이용기간 또는 정보주체로부터 개인정보를 수집 시에 동의받은
                개인정보 보유·이용기간 내에서 개인정보를 처리·보유합니다.
              </li>
              <li>
                회사는 법규 준수, 회사 업무 수행을 위해 개인정보를 보유하고 있으며, 이 경우 개인정보의 보유 기간은 다음과 같습니다.<br />
                가. 보유 이유 : 본인 확인 절차에 활용합니다.<br />
                나. 보유 기간 : 본인의 별도의 의사표시가 없는 한 회사가 제공하는 서비스 등을 이용하지 않은 고객에 대하여
                3년까지 보유하며, 법령상 의무를 준수하기 위하여 필요한 경우 법령이 정한 기간까지 보유합니다.
              </li>
            </ol>
          </section>

          <section id="article3" className="privacy-section">
            <h2><span className="article-num">3.</span> 제3자에 대한 제공</h2>
            <p>
              회사는 고객의 개인정보를 원칙적으로 외부에 제공하지 않습니다. 다만, 다음 각 호의 경우는 예외로 합니다.
            </p>
            <ol>
              <li>
                회사는 고객의 상담 또는 민원이 세아그룹의 다른 계열회사에 관한 사항인 경우, 고객에 대한 원활한
                서비스 제공을 위하여 개인정보 보호법 제17조 제1항 제1조에 따라 해당 정보주체의 동의를 얻어
                계열회사에 고객의 개인정보를 제공할 수 있습니다.
              </li>
              <li>
                회사는 세아그룹 계열사에게 임직원 간의 정보 공유를 목적으로 고객의 개인정보를 제공할 수 있습니다.
              </li>
              <li>
                법령의 규정에 의거하거나, 수사 목적으로 법령에 정해진 절차와 방법에 따라 수사기관의 요구가 있는 경우
                고객의 동의 없이 고객의 개인정보를 해당 수사기관 등에 제공할 수 있습니다.
              </li>
              <li>
                회사는 다음과 같이 재난, 감염병, 급박한 생명·신체 위험을 초래하는 사건·사고, 급박한 재산 손실 등의
                긴급상황이 발생하는 경우 정보주체의 동의 없이 관계기관에 개인정보를 제공할 수 있습니다.
              </li>
            </ol>
          </section>

          <section id="article4" className="privacy-section">
            <h2><span className="article-num">4.</span> 정보주체의 권리 및 행사방법</h2>
            <ol>
              <li>
                고객은 자신의 개인정보에 대해 언제든지 개인정보 열람·정정·삭제·처리정지 및 철회를 요청할 수 있습니다.
              </li>
              <li>
                제1항에 따른 권리 행사는 이메일 또는 전화를 통하여 하실 수 있으며 회사는 이에 대해 지체 없이 조치하겠습니다.
              </li>
              <li>
                고객이 개인정보의 오류 등에 대한 정정 또는 삭제를 요구한 경우에는 회사는 정정 또는 삭제를 완료할 때까지
                당해 개인정보를 이용하거나 제공하지 않습니다.
              </li>
              <li>
                제1항에 따른 권리 행사는 고객의 법정대리인이나 위임을 받은 자 등 대리인을 통하여 하실 수 있습니다.
                이 경우 &quot;개인정보 처리 방법에 관한 고시 별지 제11호&quot; 서식에 따른 위임장을 제출하여야 합니다.
              </li>
              <li>
                고객은 「개인정보 보호법」 등 관계법령을 위반하여 회사가 처리하고 있는 정보주체 본인이나 타인의
                개인정보 및 사생활을 침해하여서는 아니됩니다.
              </li>
            </ol>
          </section>

          <div className="privacy-footer-note">
            <p>© 주식회사 브이엔티지 (VNTG). All rights reserved.</p>
            <p>문의: <a href="mailto:secu@vntgcorp.com">secu@vntgcorp.com</a> · 02-6970-1600</p>
          </div>
        </div>
      </main>
    </div>
  );
};

export default PrivacyPolicyPage;
